export default "__VITE_ASSET__d7b5f495__"